class SelectMobileUrlDropdown extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
    this.lastVisible = null;
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
  }

  connectedCallback() {
    // Dropdown logic
    const dropdown = this.querySelector('.professional-custom-dropdown');
    if (!dropdown) return;

    const selected = dropdown.querySelector('.dropdown-selected');
    const options = dropdown.querySelector('.dropdown-options');

    if (selected && options) {
      selected.addEventListener('click', function() {
        options.classList.toggle('show');
        selected.classList.toggle('open');
      });

      options.querySelectorAll('.dropdown-option').forEach(option => {
        option.addEventListener('click', function() {
          selected.textContent = this.textContent;
          options.classList.remove('show');
          selected.classList.remove('open');
          const url = this.getAttribute('data-link');
          if (url) window.location.href = url;
        });
      });

      document.addEventListener('click', this.handleDocumentClick);
    }

   // Element to observe (outside the component)
  const target = document.querySelector('.hero-banner-joint-inner-wrapper, .hero-banner-professionals-products'); 
  if (!target) return;

    const stickyDropdown = dropdown;

    const handleVisibility = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && this.lastVisible !== true) {
          stickyDropdown.classList.remove('visible');
          this.lastVisible = true;
        } else if (!entry.isIntersecting && this.lastVisible !== false) {
          stickyDropdown.classList.add('visible');
          this.lastVisible = false;
        }
      });
    };

    this.observer = new IntersectionObserver(handleVisibility, {
      threshold: 0.1
    });

    this.observer.observe(target);
  }

  handleDocumentClick(e) {
    const dropdown = this.querySelector('.professional-custom-dropdown');
    const options = dropdown ? dropdown.querySelector('.dropdown-options') : null;
    if (dropdown && options && !dropdown.contains(e.target)) {
      options.classList.remove('show');
    }
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
    document.removeEventListener('click', this.handleDocumentClick);
  }
}

customElements.define('select-mobile-url', SelectMobileUrlDropdown);